import React from 'react';
import logo from '../../Assets/mou.png';
import logo1 from '../../Assets/anuvadini.png';
import logo2 from '../../Assets/logo.png';
import './Header.css';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import JasonFile from "../../Pages/formLangfields.json";

function useHeader({isAdminPage,langCodeDrop}) {
	const navigate = useNavigate();
	const [isLogin, setIsLogin] = useState(false);
	const [langCode, setLangCode] = useState();

	useEffect(() => {
		let isLogin = localStorage.getItem("isLogin");
		let selectedLang = localStorage.getItem("selectedLang");
		setIsLogin(isLogin);
		setLangCode(selectedLang);
	}, []);

	useEffect(()=>{
		if(langCodeDrop){
			setLangCode(langCodeDrop)
		}
	},[langCodeDrop])

	const handleLogout = () => {
		localStorage.setItem("isLogin", false);
		localStorage.removeItem("token");
		navigate("/govtofindiascheme");
		navigate(0);
	};
	
	const handleLogin = () => {
		navigate('/govtofindiascheme/login');
		navigate(0);
	};

	const handleAdminButton = () => {
		navigate('/govtofindiascheme/add-query');
		navigate(0);
	}
	
	return (
		<>
			<div className="containerh">
				<header className="header">
					<div className="common">
						<div className="wrapper">
							<a target="_blank" rel="noreferrer" href="https://anuvadini.aicte-india.org/" >
								<img className="image" src={logo1} alt=''/>
							</a>
						</div>
						<div className="wrapper">
						<a target="_blank" rel="noreferrer" href="https://lawmin.gov.in/" className="minstry" >
							<img className="image1" src={logo} alt='' />
							</a>
						</div>
						<div className="wrapper aicte">
						<a target="_blank" rel="noreferrer" href="https://www.aicte-india.org/" className="aicte">
							<img className="image2" src={logo2} alt='' />
							</a>
						</div>
						
					</div>
					<div className='selfhome text-end'>
					<Link to="/govtofindiascheme">Home</Link>
					</div>
					{/* {langCode ? <>
						{isLogin == 'true' ? <>
						<div className='d-flex justify-content-end buttonmargin'>
							{isAdminPage?<></>:
								<div className="wrapper">
									<button className="button w-auto" onClick={() => handleAdminButton()} >
										<b>{JasonFile[25][langCode]}</b>
									</button>
								</div>
							}
							<div className="wrapper">
								<button className="button w-auto" onClick={() => handleLogout()} >
									<b>{JasonFile[23][langCode]}</b>
								</button>
							</div>
							</div>
						</> : <>
							<div className="wrapper">
								<button className="button w-auto" onClick={() => handleLogin()}>
									<b>{JasonFile[22][langCode]}</b>
								</button>
							</div>
						</>}
					</>:<></>} */}
				</header>
			</div>
		</>
	)
}

export default useHeader;